import React, { Component } from 'react'

import setup from '../../../module/setup'
import Workout from '../../Workout/Workout'

export default class WorkoutScene extends Component {
  render() {
    const { history, match } = this.props
    const { params } = match
    const { questionBankId } = params
    const goToMyDashboard = () => {
      history.push(`/${setup.myDashboard.path}`)
    }
    return <Workout questionBankId={questionBankId} goToMyDashboard={goToMyDashboard} />
  }
}



// WEBPACK FOOTER //
// ./src/component/_scenes/Scene/Workout.jsx